import { gql } from '@apollo/client'
import { Copropriete } from './copropriete.fragment'

export const Coproprietaire = {
  fragments: {
    coproprietaire: gql`
      fragment CoproprietaireLots on d4_coproprietaire {
        id
        matricules {
          id
          passwd
          login
          permalink
          copropriete {
            trigramme
          }
        }
        lot_coproprietaires(where: { lot: { copropriete: { statutcopropriete: { _eq: 0 } } } }) {
          lot {
            id
            nature
            batiment {
              libellecourt
              libelle
              id
            }
            numerodelot
            copropriete {
              id
              trigramme
              gestionnaire {
                id
                nom
                prenom
              }
              gestionnaireSedentaire {
                id
                nom
                prenom
              }
              comptable {
                id
                nom
                prenom
              }
            }
          }
        }
      }
      ${Copropriete.fragments.gestionnaire}
    `,
  },
}
